import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BundleComponent } from 'src/app/bundles/bundle/bundle.component';
import { ExperimentListForBundleComponent } from 'src/app/bundles/experiment-list-for-bundle/experiment-list-for-bundle.component';
import { ExperimentFormatPipe } from 'src/app/pipes/experiment-format.pipe';
import { AppStateService } from 'src/app/services/app-state.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { LabpartnerService } from 'src/app/services/labpartner.service';
import { ExperimentStatus, StudyType } from 'src/app/services/labpartner.service.model';
import { LoggingService } from 'src/app/services/logging.service';
import { UserAccountService } from 'src/app/services/user-account.service';
import { BundleService } from 'src/app/shared/bundle.service';
import { ExperimentService } from 'src/app/shared/experiment.service';
import { NotificationService } from 'src/app/shared/notification.service';

@Component({
  selector: 'app-select-external-control',
  templateUrl: './select-external-control.component.html',
  styleUrls: ['./select-external-control.component.scss'],
  standalone: false,
})
export class SelectExternalControlComponent
  extends ExperimentListForBundleComponent
  implements OnInit, OnDestroy
{
  ExperimentStatus = ExperimentStatus;
  constructor(
    public configService: ConfigurationService,
    public bundleService: BundleService,
    protected experimentService: ExperimentService,
    protected apiService: LabpartnerService,
    public accountService: UserAccountService,
    public appState: AppStateService,
    protected notificationService: NotificationService,
    protected loggingService: LoggingService,
    protected experimentPipe: ExperimentFormatPipe,
    public dialogRef: MatDialogRef<BundleComponent>,
  ) {
    super(
      configService,
      bundleService,
      experimentService,
      apiService,
      accountService,
      appState,
      notificationService,
      loggingService,
      experimentPipe,
      dialogRef,
    );
  }

  // Filter out experiments that are not external controls
  filterInitialExperiments(): void {
    this.experiments = this.experiments.filter(x => {
      return (
        x.studyType == StudyType.DailyExternalControls &&
        (x.status === ExperimentStatus.ReadyToTest || x.status === ExperimentStatus.Complete)
      );
    });
  }

  // Add the selected experiment to the bundle
  onAdd(row: any) {
    this.bundleData.data = [row];
    this.selectedExperiments = [row];
    const experimentIds = this.selectedExperiments.map(x => x.experimentId.toString());
    this.bundleExperimentIds = experimentIds.toString();
    this.bundleService.form.patchValue({
      experimentIds: this.bundleExperimentIds,
    });
    this.bundleData._updateChangeSubscription();
  }

  // Validate the form
  isFormDisabled() {
    return this.selectedExperiments.length === 0;
  }

  // Submit the form
  onSubmit() {
    this.dialogRef.close({
      ok: true,
      data: this.selectedExperiments[0],
    });
  }
}
